import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Profile from "@/components/screens/Profile";
import { PROFILE_MESSAGES, ProfileMessages } from "@/messages/profile/profile.messages";
import translationService from "@/services/translation.service";
import { Language, Translation } from "@/types/language.types";

const ProfilePage: React.FC = () => {
  const { lang = "PT-BR" } = useParams();
  const [messages, setMessages] = useState<Translation<ProfileMessages> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<ProfileMessages>(
          PROFILE_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return <Profile messages={messages} selectedNavigationItem="profile" />;
};

export default ProfilePage;
